export default __webpack_public_path__ + "WrkCompleted6.3db9a46a.mov";